module.exports = "/out/f317a99a65aca324a5b6145ea989ec12.svg";